import React, { useCallback, useLayoutEffect, useState } from 'react';

/**
 * Elementets egen bredd, uppdaterad när den ändras. För layouter som beror på hur mycket plats
 * en komponent FÅR (en kolumn bredvid en karta), inte på fönstret — det CSS:ens container
 * queries gör, men styled-components 5 (stylis 3) skriver sönder @container-regler.
 */
const useElementWidth = (): { width: number | null; ref: React.RefCallback<HTMLElement> } => {
  const [width, setWidth] = useState<number | null>(null);
  const [element, setElement] = useState<HTMLElement | null>(null);

  const ref = useCallback((node: HTMLElement | null) => setElement(node), []);

  // Layout-effekt: mätningen ska vara klar före första målningen, annars blinkar fel layout.
  useLayoutEffect(() => {
    if (!element) return undefined;
    const measure = () => setWidth(element.getBoundingClientRect().width);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return { width, ref };
};

export default useElementWidth;
